import { useAppContext } from '@/context/AppContext';
import useWindowDimensions from '@/hooks/useWindowDimensions';
import { getDimensions } from '@/utils';
import clsx from 'clsx';
import { BlacklistHospital, ChevronRight } from 'ui/icons';

interface IProps {
  onOpenChange: (open?: boolean) => void;
}

const CantFindHospitalWidget = ({ onOpenChange }: IProps) => {
  const [[windowWidth]] = useWindowDimensions();
  const footerDimensions = getDimensions('claims-footer');
  const backButtonBarDimensions = getDimensions('claims-back-bar');

  const { isWebView } = useAppContext();

  return (
    <div
      onClick={() => onOpenChange(true)}
      className={clsx({
        'cursor-pointer z-10 flex flex-row fixed transform -translate-x-1/2 bg-white p-4 items-center justify-center rounded-2xl shadow-[0px_2px_8px_0px_rgba(0,0,0,0.32)] gap-3 w-[90%] sm:w-auto':
          true,
        'left-1/2': true, // Default for small screens
        // [`lg:left-[calc(50% + 32px + ${
        //   backButtonBarDimensions?.width ?? 0
        // }px)]`]: true, // For large screens
      })}
      style={{
        left:
          (windowWidth ?? 0) > 1024
            ? `calc(50% + ${backButtonBarDimensions?.width ?? 0}px)`
            : '50%',
        bottom:
          footerDimensions.height > 0
            ? footerDimensions.height + 20
            : isWebView
              ? '8px'
              : '36px',
      }}
    >
      <div className="">
        <BlacklistHospital width={24} height={24} />
      </div>
      <div className="font-body flex flex-col text-sm">
        <p className="font-semibold text-mobile-text-main">
          Avoid blacklisted hospitals
        </p>
        <p className="text-mobile-text-hierarchy-1 font-normal text-xs">
          Check if your hospital is blacklisted or excluded before proceeding
        </p>
      </div>
      <div>
        <ChevronRight />
      </div>
    </div>
  );
};

export default CantFindHospitalWidget;
